import { MDXRemoteSerializeResult } from 'next-mdx-remote';

// TODO make extensible
export enum MarketplaceCategorySlug {
  Analytics = 'analytics',
  Integration = 'integration',
  Workspace = 'workspace',
  Aiml = 'ai-ml',
  Os = 'os',
  Devtools = 'devtools',
  Addons = 'mk8s',
  Databases = 'databases',
  Networks = 'networks',
  DataMigration = 'data-migration',
  DevManagement = 'dev-management',
}

export type Seo = {
  title: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
};

export type FilteredItem = {
  id: string;
  name: string;
};
export type PreparedCheckbox = FilteredItem & {
  count: number;
};

export type FilterKey = keyof ParsedProductPreview;
export type EmptyFilterBlock = {
  filterKey: FilterKey;
  titleKey: string;
  search?: boolean;
  collapsable?: boolean;
};

export type ParsedFilterBlock = EmptyFilterBlock & {
  options: PreparedCheckbox[];
};

export type AvailableFilters = ParsedFilterBlock[];

export type SelectedFilters = Record<string, string[]>;

export enum ProductPreviewPaymentType {
  Unspecified = 'TARIFF_PAYMENT_TYPE_UNSPECIFIED',
  Free = 'TARIFF_PAYMENT_TYPE_FREE',
  Recurring = 'TARIFF_PAYMENT_TYPE_RECURRING',
  Other = 'TARIFF_PAYMENT_TYPE_OTHER',
}

export type Tag = {
  custom: boolean;
  id?: string;
  name: string;
};
export type ParsedTag = Omit<Tag, 'id' | 'custom'> & { id: string };

export type ProductPreview = {
  categoryId?: string;
  category: MarketplaceCategorySlug;
  displayName: string;
  logoLink: string;
  metadata: string;
  previewText: string;
  priority: number;
  popular: boolean;
  productId: string;
  /**
   * @deprecated поддержка productTypes
   * */
  productType?: string;
  productTypes?: string[];
  seoTitle: string;
  seoDescription: string;
  slug: string;
  tags: Tag[];
};

export enum MlSpaceKind {
  Demo = 'demo',
  Deploy = 'deploy',
  Service = 'service', // only SaluteSpeech
  Dataset = 'dataset',
  Model = 'model',
}

export type ParsedMetaData = {
  mockId?: string;
  seoTitle?: string;
  seoDescription?: string;
  kind?: MlSpaceKind;
  customButtonLink?: string;
  customButtonText?: string;
};

export type ParsedProductPreview = Omit<
  ProductPreview,
  'metadata' | 'tags' | 'productType'
> & {
  metadata: ParsedMetaData | null;
  tags: ParsedTag[];
  productType: ParsedTag[];
};

export type MarketplaceProductsResponse = {
  items: ProductPreview[];
  count: number;
};

export type Category = {
  displayName: string;
  id?: string;
  description: string;
  type: MarketplaceCategorySlug;
  seoTitle?: string;
  seoDescription?: string;
  number: number;
};
export type MarketplaceCategoriesResponse = {
  items: Category[];
  count: number;
};

export type ProductType = {
  displayName: string;
  type: string;
};
export type MarketplaceProductTypeResponse = {
  items: ProductType[];
  count: number;
};

export type MarketplaceCategory = Category & {
  slug: MarketplaceCategorySlug;
  cards: ParsedProductPreview[];
  availableFilters?: AvailableFilters;
};

export type FiltersType = { [p: string]: string[] };

export type MarketplaceProps = {
  cards: ParsedProductPreview[];
  categories: MarketplaceCategory[];
  currentCategory: string;
};

// Product
export enum ContactSlaPeriodType {
  Unspecified = 'CONTACT_SLA_PERIOD_TYPE_UNSPECIFIED',
  Minutes = 'CONTACT_SLA_PERIOD_TYPE_MINUTES',
  Hours = 'CONTACT_SLA_PERIOD_TYPE_HOURS',
  Days = 'CONTACT_SLA_PERIOD_TYPE_DAYS',
}

export enum FormLicenseType {
  Unspecified = 'TARIFF_LICENSE_TYPE_UNSPECIFIED',
  Byol = 'TARIFF_LICENSE_TYPE_BYOL',
  Sale = 'TARIFF_LICENSE_TYPE_SALE',
}
export enum FormPaymentType {
  Unspecified = 'TARIFF_PAYMENT_TYPE_UNSPECIFIED',
  Free = 'TARIFF_PAYMENT_TYPE_FREE',
  Recurring = 'TARIFF_PAYMENT_TYPE_RECURRING',
  Other = 'TARIFF_PAYMENT_TYPE_OTHER',
}

export enum FormSoftwareType {
  Unspecified = 'SOFTWARE_TYPE_UNSPECIFIED',
  Rus = 'SOFTWARE_TYPE_RUS',
  International = 'SOFTWARE_TYPE_INTERNATIONAL',
}
export enum FormStatus {
  Unspecified = 'STATUS_UNSPECIFIED',
  Draft = 'STATUS_DRAFT',
  Checking = 'STATUS_CHECKING',
  ReadyForPublishing = 'STATUS_READY_FOR_PUBLISHING',
  Published = 'STATUS_PUBLISHED',
  Hidden = 'STATUS_HIDDEN',
  Deleted = 'STATUS_DELETED',
}
export enum IntegrationAccessCondition {
  Unspecified = 'ACCESS_CONDITION_TYPE_UNSPECIFIED',
  Mlspace = 'ACCESS_CONDITION_TYPE_MLSPACE',
  Evolution = 'ACCESS_CONDITION_TYPE_EVOLUTION',
  ServerlessContainer = 'ACCESS_CONDITION_TYPE_SERVERLESS_CONTAINER',
}
export enum IntegrationType {
  Unspecified = 'INTEGRATION_TYPE_UNSPECIFIED',
  Mlspace = 'INTEGRATION_TYPE_MLSPACE',
  VmImage = 'INTEGRATION_TYPE_VM_IMAGE',
  Addon = 'INTEGRATION_TYPE_ADDON',
  Redirect = 'INTEGRATION_TYPE_REDIRECT',
  Order = 'INTEGRATION_TYPE_ORDER',
  Gigacode = 'INTEGRATION_TYPE_GIGACODE',
  Gigachat = 'INTEGRATION_TYPE_GIGACHAT',
  ServerlessContainer = 'INTEGRATION_TYPE_SERVERLESS_CONTAINER',
  EvoMlModels = 'INTEGRATION_TYPE_EVO_ML_MODELS',

  /**
   * @deprecated будет удалено после выкатки нового контракта
   * */
  Evolution = 'INTEGRATION_TYPE_EVOLUTION',
  /**
   * @deprecated будет удалено после выкатки нового контракта
   * */
  Mk8s = 'INTEGRATION_TYPE_MK8S',
}
export enum TariffPeriodType {
  Unspecified = 'TARIFF_PERIOD_TYPE_UNSPECIFIED',
  Hour = 'TARIFF_PERIOD_TYPE_HOUR',
  Day = 'TARIFF_PERIOD_TYPE_DAY',
  Month = 'TARIFF_PERIOD_TYPE_MONTH',
  Value3Month = 'TARIFF_PERIOD_TYPE_3MONTH',
  Value6Month = 'TARIFF_PERIOD_TYPE_6MONTH',
  Year = 'TARIFF_PERIOD_TYPE_YEAR',
  Unlimited = 'TARIFF_PERIOD_TYPE_UNLIMITED',
}

export type Advantage = {
  description: string;
  id: string;
  image?: File;
  imageLink?: string;
  name: string;
  number: number;
};
export type Contact = {
  contacts: string;
  id: string;
  slaAmount?: number;
  slaPeriodType?: ContactSlaPeriodType;
};
export type License = {
  id?: string;
  link?: string;
  owner?: string;
};
export type Link = {
  id?: string;
  link: string;
  name: string;
  number: number;
};
export type Documentation = Link;
export type Instruction = {
  id: string;
  steps: Step[];
  // TODO: опциональный временно
  productType?: string;
};
export type Integration = {
  accessCondition?: IntegrationAccessCondition;
  buttonText?: string;
  buttonLink?: string;
  freeTier?: boolean;
  id?: string;
  link?: string;
  type: IntegrationType;
  externalId?: string;
  rootDiskSize?: string | number;
  productType?: string;
  packageLink?: string;
  infoOnly: boolean;
};
export type Step = {
  description?: string;
  id: string;
  name: string;
  number: number;
};

export type Tariff = {
  description: string;
  id: string;
  name?: string;
  number: number;
  periodType?: TariffPeriodType;
  price?: string;
  usersAmount?: number;
  productType?: string;
  paymentType?: string;
  licenseType?: string;
};
export type Video = {
  s3Link: string;
  description?: string;
  id: string;
  link: string;
  preview?: File;
  previewLink: string;
  title: string;
};

// TODO: @fix удалить deprecated поля и заменить на новый контракт
export type MarketplaceNewProduct = Omit<ProductPreview, 'priority'> & {
  /**
   * @deprecated используй { activationInstruction(s) };
   */
  activationInstruction?: Instruction;
  /**
   * @deprecated используй { deactivationInstruction(s) };
   */
  deactivationInstruction?: Instruction;
  /**
   * @deprecated используй { tariffs.licenseType }
   */
  licenseType?: string;
  /**
   * @deprecated используй { tariffs.paymentType };
   */
  paymentType?: string | null;
  /**
   * @deprecated  Поддержка productTypes;
   */
  productType?: string;
  /**
   * @deprecated  Поддержка integrations;
   */
  integration?: Integration;

  /* TODO: опциональные временно - либо могут прийти, либо старый контракт */
  activationInstructions?: Instruction[];
  deactivationInstructions?: Instruction[];
  integrations?: Integration[];
  productTypes?: string[];

  /* TODO: фантомные поля, которые приходят с бэка, но не совпадали по типам (в мапе жил тайпкаст) */
  packageFileLink?: string;
  advantageType?: string;
  rootDiskSize?: string | number;
  infoOnly?: boolean;

  advantages: Advantage[];
  createdAt?: string;
  createdBy?: string;
  customerId: string;
  documentations?: Documentation[];
  fullDescription: string;
  id: string;
  license?: License;

  logo?: File;
  orderContact?: Contact;
  softwareType: FormSoftwareType;
  status: FormStatus;
  tariffs: Tariff[];
  techContact: Contact;
  updatedAt: string;
  updatedBy: string;
  video?: Video;
};

export type MarketplaceMappedNewProduct = Omit<
  MarketplaceNewProduct,
  | 'metadata'
  | 'tags'
  | 'activationInstructions'
  | 'productTypes'
  | 'integration'
> & {
  activationInstructions: Instruction[] | null;
  productTypes: string[];
  integrations?: Integration[];
  category: MarketplaceCategorySlug;
  metadata: ParsedMetaData | null;
  tags: ParsedTag[];
};

export type ParsedStep = {
  description?: MDXRemoteSerializeResult;
  id: string;
  name: string;
  number: number;
};
export type MarketplaceParsedNewProduct = Omit<
  MarketplaceNewProduct,
  | 'metadata'
  | 'tags'
  | 'category'
  | 'fullDescription'
  | 'activationInstructions'
  | 'advantages'
  | 'tariffs'
  | 'orderContact'
  | 'techContact'
> & {
  advantages: (Omit<Advantage, 'description'> & {
    description: MDXRemoteSerializeResult;
  })[];
  tariffs: (Omit<Tariff, 'description'> & {
    description: MDXRemoteSerializeResult;
  })[];
  activationInstructions: Omit<Instruction, 'steps'> & { steps: ParsedStep[] };
  category: MarketplaceCategorySlug;
  fullDescription: MDXRemoteSerializeResult;
  metadata: ParsedMetaData | null;
  orderContact:
    | (Omit<Contact, 'contacts'> & { contacts: MDXRemoteSerializeResult })
    | null;
  tags: ParsedTag[];
  techContact: Omit<Contact, 'contacts'> & {
    contacts: MDXRemoteSerializeResult;
  };
};
